// Client-only row key for grid items that haven't been persisted yet. It never reaches the
// backend (the API regenerates identities / matches by code), so it just needs to be unique
// within the small in-memory collection being edited.
export function newClientUid(): string {
  return `tmp-${Math.random().toString(36).substring(2, 15)}`;
}

// The all-zero guid the backend treats as "new" for an aggregate child.
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

// Collapse a client-only temp uid (or any empty / non-guid value) to the empty guid so it can be
// sent to a backend field typed as a Guid. Real backend guids pass through unchanged.
export function toBackendUid(uid: string | null | undefined): string {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(uid ?? '')
    ? (uid as string)
    : EMPTY_GUID;
}
